import { asMap, observable, action, computed } from 'mobx';
import { Database } from '../firebaseInit.js';

class Lecture {
  @observable status = 0;
  constructor(id, data=null) {
    if(data) {
      this.set(Object.assign(this, data, { status: 200 }));
    }
    else {
      Database.child('lectures').child(id).once('value', (snap) => {
        const lecture = snap.val();
        (lecture) ? this.set( Object.assign(this, snap.val(), { status: 200 }) ) : this.set( {status: 404} );
      });
    }
  }
  set(data) {
    Object.assign(this, data);
  }
}

class LectureStore {
  @observable lectures = asMap();
  courseLoads = [];
  @action loadByCourseId = (courseId) => {
    if ( !this.courseLoads.includes(courseId) ) {
      Database.child('lectures').orderByChild('courseId').equalTo(courseId).once('value', (snap) => {
        this.courseLoads.push(courseId);
        snap.forEach( (lecture) => {
          this.lectures.set( lecture.key, new Lecture(lecture.key, lecture.val()) );
        });
      });
    }
  }
  @action loadLectureById = (lectureId) => {
    if ( !this.lectures.has(lectureId) ) {
      this.lectures.set(lectureId, new Lecture(lectureId));
    }
  }

  getLecturesByCourseId = (courseId) => {
    this.loadByCourseId(courseId);
    return this.lectures.entries().filter( ([id, lecture]) => lecture.courseId === courseId);
  }
}

export default LectureStore;


/** WEBPACK FOOTER **
 ** ./src/js/state/lecture.js
 **/